<template>
  <div class="d-flex flex-column w-100" style="gap: 5px;" :class="isPhone ? 'order-1' : ''">
    <div class="lodge-info-container">
      <div class="d-flex flex-column lodge-info-box">
        <div class="d-flex">
          <img src="../../images/badge-trotter.png" v-set-alt class="trotter-badge" style="width: 21px;height: 26px;" />
          <p class="text-green ml-2 mb-1" :class="isPhone ? 'raleway-semi-p14' : 'raleway-semi-p15'">VOUS ÊTES MEMBRE DU CLUB HORTENSE ?</p>
        </div>
        <p class="text-green mb-0" :class="isPhone ? 'raleway-reg-p14' : 'raleway-reg-p14'">Profitez des <span :class="isPhone ? 'raleway-semi-p14' : 'raleway-semi-p14'" style="font-style: italic">privilèges exclusifs</span> selon votre statut de fidélité.</p>
      </div>
      <div class="d-flex flex-column lodge-info-items" v-if="!isPhone || showLodgeInfo">
        <div
          v-for="(privilege, index) in infinitePrivileges"
          :key="index"
          class="d-flex lodge-info-item ml-2"
        >
          <img src="../../images/lock_green.svg" v-set-alt class="info-icon" />
          <p class="mb-0 text-green ml-2" :class="isPhone ? 'raleway-semi-p14' : 'raleway-semi-p15'">{{ privilege }}</p>
        </div>
        <div class="text-green" :class="isPhone ? 'raleway-reg-p14' : 'raleway-reg-p14'" @click="openModal()" style="cursor: pointer;">
          <span :class="isPhone ? 'raleway-semi-p14' : 'raleway-semi-p14'">Pas encore membre ?</span> Aucun problème, vous pourrez vous inscrire gratuitement <span class="text-underline">ici</span>.
        </div>
      </div>
      <div class="d-flex w-100" v-if="isPhone && showLodgeInfo">
        <a @click="showLodgeInfo = false" class="link-collapse raleway-semi-p11">Voir moins <img src="../../images/Fleche haut.svg" style="width: 8px;height: 8px;color:black;" v-set-alt></a>
      </div>
      <div class="d-flex w-100" v-else-if="isPhone && !showLodgeInfo">
        <a @click="showLodgeInfo = true" class="link-collapse raleway-semi-p11">Voir plus <img src="../../images/flechebas-simple.svg" style="width: 8px;height: 8px;color:black;" v-set-alt></a>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <LodgingDiscountBadge :lodging="lodging" class="px-0" />
    </div>
  </div>
</template>

<script>
import LodgingDiscountBadge from "../shared/LodgingDiscountBadge.vue";

export default {
  name: "LodgingInfo",
  components: {
    LodgingDiscountBadge,
  },
  props: {
    lodging: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showLodgeInfo: false,
    };
  },
  computed: {
    isPhone() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    infinitePrivileges() {
      // Find the Green Trotter INFINITE tier (index 3, which is 2500 points)
      if (this.lodging.green_trotters && this.lodging.green_trotters.length >= 4) {
        const infiniteTier = this.lodging.green_trotters[3];
        if (infiniteTier && infiniteTier.gifts) {
          return infiniteTier.gifts.map(gift => gift.name);
        }
      }
      // Return empty array if data is not available
      return [];
    },
  },
  methods: {
    openModal() {
      this.$root.$emit('openModal')
    },
  }
};
</script>

<style scoped lang="scss">
.lodge-info-container {
  height: fit-content;
  background: #CFE5DC99 0% 0% no-repeat padding-box;
  border-radius: 15px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 20px;
  margin-bottom: 20px;

  @media screen and (max-width: 768px) {
    padding: 15px;
    gap: 10px;
    margin-bottom: 0;
  }
}

.text-green {
  color: #2C5E4B !important;
}

.lodge-info-box {
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(44, 94, 75, 0.2);

  @media screen and (max-width: 768px) {
    border-bottom: unset;
    padding-bottom: 0px;
  }
}

.lodge-info-items {
  gap: 12px;
}

.lodge-info-item {
  align-items: center;
  
  .info-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
}

.link-collapse {
  color: black;
  text-decoration: underline;
  cursor: pointer;
}
</style>